import { render, staticRenderFns } from "./NewApplicationFormPageV2.vue?vue&type=template&id=322ab47c&"
import script from "./NewApplicationFormPageV2.vue?vue&type=script&lang=ts&"
export * from "./NewApplicationFormPageV2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('322ab47c')) {
      api.createRecord('322ab47c', component.options)
    } else {
      api.reload('322ab47c', component.options)
    }
    module.hot.accept("./NewApplicationFormPageV2.vue?vue&type=template&id=322ab47c&", function () {
      api.rerender('322ab47c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Applicant/Details/Application/NewApplicationFormPageV2.vue"
export default component.exports